// @ts-strict-ignore
import { GetConfig } from "phoenix/constants";

export const DispatchIntoSnexStore = (action: any) => GetConfig().Store.dispatch(action)